/**
 * Domain Configuration Utility
 * Detects the current domain and returns school-specific branding
 */

export const getSchoolConfig = () => {
  const hostname = window.location.hostname;

  // Check if the domain contains cpsjaldharichowk
  if (hostname.includes('cpsjaldharichowk')) {
    return {
      schoolName: 'CPS JALDHARI CHOWK',
      fullName: 'Central Public School',
      subtitle: 'School Management System',
      domain: 'cpsjaldharichowk',
      email: 'cpsjaldharichowk2006@gmail.com',
      phones: ['7050596081', '9060101109'],
      establishedYear: 2006
    };
  }

  // Default to KRM Madhubani
  return {
    schoolName: 'KRM Madhubani',
    fullName: 'Kingdom of Rising Minds',
    subtitle: 'School Management System',
    domain: 'krmmadhubani',
    email: 'krmmadhubani@gmail.com',
    phones: ['7091506644', '7091504131'],
    establishedYear: 2024
  };
  // return {
  //     schoolName: 'CPS JALDHARI CHOWK',
  //     fullName: 'Central Public School',
  //     subtitle: 'School Management System',
  //     domain: 'cpsjaldharichowk'
  //   };
};

export const isCPSDomain = () => {
  return window.location.hostname.includes('cpsjaldharichowk');
};

export const isKRMDomain = () => {
  return window.location.hostname.includes('krmmadhubani');
};
